@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0 && !$isReadOnly() && !$isDispatchRecipientInvalid() && !$isProcessInvalidStatus()) {
            <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.TaskDispatchProcess"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        <!-- Task body: visão do executor -->
        @if ($shouldLetPublicAgentInteract()) {
            <div class="message-container">
                <div>Processo:</div>
                <div class="process-container my-3">
                    <div class="position-relative my-1">
                        <span class="document-highlight" (click)="goToProcess()" (keyDown)="goToProcess()">
                            <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do Processo">{{$processProtocol()}}</span>
                            <span class="info-font d-inline-block" matTooltip="Clique para ser redirecionado ao processo capturado no E-Docs">
                                <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{$process()?.resumo}}</u>
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            @if ($hasPendingTask()) {
                <div class="message-container">
                    <hr />
                    <div>Custódia atual:</div>
                    <div class="my-3">
                        <span class="uppercase info-font text-highlight d-inline-block">{{$custodyHolder()}}</span>
                    </div>
                </div>

                <div class="message-container">
                    <hr />
                    <div>Destinatário:</div>
                    <div class="my-3">
                        <span class="uppercase info-font text-highlight d-inline-block">
                            {{$configSchema()?.taskDispatchProcess?.dispatchRecipient.name || $inputData().recipientName}}
                        </span>
                    </div>
                </div>
            }

            <div class="message-container">
                <hr />
                <div>Mensagem do Despacho:</div>
                <div class="my-3">
                    <span class="info-font text-highlight d-inline-block p-2"
                          [safeHtmlContent]="getDispatchSummary()"
                    ></span>
                </div>
            </div>
        }

        @if (!$hasPendingTask()) {
            <!-- Task info: Realizada -->
            <div class="message-container">
                <div class="mb-3">
                    O Processo disponível no protocolo E-Docs
                    <span class="info-font text-highlight">{{$process()?.protocolo}}</span>
                    foi <b>despachado</b> para:
                </div>
                <div class="mb-3">
                    <span class="uppercase info-font text-highlight d-inline-block">
                        {{$recipient().name || $inputData().recipientName}}
                    </span>
                </div>
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$shouldLetPublicAgentInteract()) {
                <!-- Task body: visão do requerente -->
                <div class="message-container">
                    <div class="mb-3">
                        Aguardando despacho do Processo por:
                    </div>
                    <div>
                        <span class="uppercase info-font text-highlight d-inline-block">{{$dispatcher()}}</span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                @if (!$isReadOnly() && $canDispatchProcess() && !$isDispatchRecipientInvalid()) {
                    <div class="form-container">
                        <hr />
                        <div class="footer">
                            <button type="button" class="btn btn-outline-primary" (click)="submit()" (keyDown)="submit()">
                                Despachar Processo
                            </button>
                        </div>
                    </div>
                } @else {
                    @if ($isProcessInvalidStatus()) {
                        <div class="mt-2">
                            <span class="not-found info-font text-highlight p-2">
                                O processo <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do processo">{{$processProtocol()}}</span>
                                não se encontra em um estado <b>Ativo/Em Andamento</b>
                            </span>
                        </div>
                    }

                    @if ($isDispatchRecipientInvalid()) {
                        <div class="mt-2">
                            <span class="not-found info-font text-highlight p-2">
                                O destinatário <span class="e-docs info-font text-highlight" matTooltip="Destinatário E-Docs do despacho">{{$recipient().name}}</span>
                                não é mais válido
                            </span>
                        </div>
                    }

                    @if (!$isReadOnly()) {
                        <div class="mt-5">
                            <span class="info-font document-highlight p-2">
                                No contexto atual, a única ação possível para esta instância de Fluxo é o seu cancelamento
                            </span>
                        </div>
                    }
                }
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
